import React from "react";
import { NavLink, useParams } from "react-router-dom";
import "./SideBar.css";
import { useAuth0Context } from "../../context/Auth0Context";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { buildPath } from "../../routes/routesPath";

const AppLeftSideBar = ({ type }) => {
  const params = useParams();
  const orgId = params.orgId;
  const appId = params.appId;
  const { user } = useAuth0Context();
  const navigationItems = generateNavigationConfig(type, user.role_names || []);

  return (
    <div className="top_LMPopup_outerBox">
      {type === "app" && (
        <div className="top_LMPopup_titleBox">
          <NavLink to={`/organization`} className="text_decoration_none">
            <div className="top_LMPopup_titleL">
              <MaterialIcon name="chevron_left" />
              <span>Organisations</span>
            </div>
          </NavLink>
        </div>
      )}
      {type === "appSettings" && (
        <div className="top_LMPopup_titleBox">
          <NavLink to={`../`} className="text_decoration_none">
            <div className="top_LMPopup_titleL">
              <MaterialIcon name="chevron_left" />
              <span>All Applications</span>
            </div>
          </NavLink>
        </div>
      )}
      <>
        {navigationItems.map((item, index) => {
          return (
            <NavLink
              key={index}
              to={item.pathFunc({ orgId, appId })}
              end={item.end}
              className={({ isActive }) => (isActive ? "top_LMPopup_appBox active" : "top_LMPopup_appBox")}
            >
              <MaterialIcon name={item.icon} />
              <span className="top_LMPopup_formLItemIcon_name">{item.label}</span>
            </NavLink>
          );
        })}
      </>
    </div>
  );
};

export default AppLeftSideBar;

const generateNavigationConfig = (type, roles) => {
  const routes = {
    appSettings: [
      {
        pathFunc: () => {}, // Placeholder
        icon: "settings",
        label: "Settings",
        roles: ["admin", "super-admin", "moderator"]
      }
    ],
    app: [
      {
        pathFunc: buildPath.orgApps,
        icon: "apps",
        label: "Applications",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgStructure,
        icon: "network_node",
        label: "Org Structure",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgThemeList,
        icon: "palette",
        label: "Screen Themes",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgUsers,
        icon: "group",
        label: "Org Users",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgGroups,
        icon: "group",
        label: "User Groups",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgUserRoles,
        icon: "assignment_ind",
        label: "User Roles",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgMonitor,
        icon: "monitor",
        label: "Monitor",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgAudit,
        icon: "fact_check",
        label: "Audit",
        roles: ["admin", "super-admin", "moderator"]
      }
      // Uncomment if needed later
      // {
      //   pathFunc: buildPath.orgAiApps,
      //   icon: "developer_guide",
      //   label: "AI Apps",
      //   roles: ["admin", "super-admin", "moderator"]
      // }
    ],
    org: [
      {
        pathFunc: buildPath.organizationList,
        icon: "corporate_fare",
        label: "Organizations",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.builderUser,
        icon: "group",
        label: "Builder Users",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.userService,
        icon: "group",
        label: "Application Users",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.releases,
        icon: "published_with_changes",
        label: "Releases",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.smTemplates,
        icon: "text_ad",
        label: "Workflow Templates",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.screenTemplates,
        icon: "menu_book",
        label: "Screen Template",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.themeList,
        icon: "palette",
        label: "Screen Themes",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.charts,
        icon: "bar_chart",
        label: "Chart Themes",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.clusterManager,
        icon: "database",
        label: "Cluster Manager",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.proxy,
        icon: "insights",
        label: "Proxy Routes",
        roles: ["admin", "super-admin", "moderator"]
      },
      {
        pathFunc: buildPath.orgUserLogs,
        icon: "history",
        label: "User Logs",
        roles: ["admin", "super-admin"]
      },
      {
        pathFunc: buildPath.UserManagement,
        icon: "manage_accounts",
        label: "User Management",
        roles: ["user-admin"]
      }
    ]
  };

  if (roles.length === 0) {
    return routes[type] || [];
  }

  return (routes[type] || []).filter((route) => route.roles.some((role) => roles.includes(role)));
};
